import { useCallback } from 'react';
import { posthogTrackEvent, SimulatorEvents } from '@/assets/posthog';

export const useSimulatorTracking = () => {
  const trackMessageSent = useCallback((messageContent: string, messageType?: string) => {
    posthogTrackEvent({
      event: SimulatorEvents.MESSAGE_SENT,
      properties: {
        messageLength: messageContent.length,
        messageType,
        timestamp: new Date().toISOString(),
      },
    });
  }, []);

  const trackInstructionAdded = useCallback((instructionText: string) => {
    posthogTrackEvent({
      event: SimulatorEvents.INSTRUCTION_ADDED,
      properties: {
        instructionLength: instructionText.length,
        timestamp: new Date().toISOString(),
      },
    });
  }, []);

  const trackFeedbackProvided = useCallback((feedbackType: string, feedbackText?: string) => {
    posthogTrackEvent({
      event: SimulatorEvents.FEEDBACK_PROVIDED,
      properties: {
        feedbackType,
        feedbackLength: feedbackText?.length,
        timestamp: new Date().toISOString(),
      },
    });
  }, []);

  const trackReleaseCreated = useCallback((releaseData: { version?: string; topicsCount?: number }) => {
    posthogTrackEvent({
      event: SimulatorEvents.RELEASE_CREATED,
      properties: {
        version: releaseData.version,
        topicsCount: releaseData.topicsCount,
        timestamp: new Date().toISOString(),
      },
    });
  }, []);

  const trackTopicViewed = useCallback((topicId: string, topicName?: string) => {
    posthogTrackEvent({
      event: SimulatorEvents.TOPIC_VIEWED,
      properties: {
        topicId,
        topicName,
        timestamp: new Date().toISOString(),
      },
    });
  }, []);

  const trackSessionStarted = useCallback((sessionType: string) => {
    posthogTrackEvent({
      event: SimulatorEvents.SESSION_STARTED,
      properties: {
        sessionType,
        timestamp: new Date().toISOString(),
      },
    });
  }, []);

  const trackSessionEnded = useCallback((sessionDuration: number, messagesCount: number) => {
    posthogTrackEvent({
      event: SimulatorEvents.SESSION_ENDED,
      properties: {
        sessionDuration,
        messagesCount,
        timestamp: new Date().toISOString(),
      },
    });
  }, []);

  const trackTrainingDataAdded = useCallback((ticketId?: string, source?: string) => {
    posthogTrackEvent({
      event: SimulatorEvents.TRAINING_DATA_ADDED,
      properties: {
        ticketId,
        source,
        timestamp: new Date().toISOString(),
      },
    });
  }, []);

  return {
    trackMessageSent,
    trackInstructionAdded,
    trackFeedbackProvided,
    trackReleaseCreated,
    trackTopicViewed,
    trackSessionStarted,
    trackSessionEnded,
    trackTrainingDataAdded,
  };
};